import type { MouseEvent } from 'react';
import type { CatalogueItem } from '../SalesLadder/useSalesCatalogue';
import { itemThumb } from './resolveIds';
import { isVideoItem, fmtDuration } from '../SalesLadder/MediaBadge';
import { VaultThumb } from '../Sales/VaultThumb';
import { font } from './style';
import { C } from './tokens';

/** Up to `max` thumbnails (video length on videos) plus a "+N" tile. `onItem`
 *  makes each loaded tile clickable on its own ("+N" opens the first hidden one).
 *  `loading` (from useResolveIds) pulses the tiles whose media isn't in yet. */
export function ThumbStrip({ accountId, ids, byId, max = 3, size = 30, onClick, onItem, title, loading }: { accountId: string; ids: string[]; byId: Map<string, CatalogueItem>; max?: number; size?: number; onClick?: () => void; onItem?: (id: string) => void; title?: string; loading?: boolean }) {
  if (!ids.length) return null;
  return (
    <div onClick={onClick} title={title} style={{ display: 'flex', gap: 3, cursor: onClick ? 'pointer' : undefined, flex: 'none' }}>
      {ids.slice(0, max).map((id) => {
        const it = byId.get(id);
        const vid = it ? isVideoItem(it.type) : false;
        const click = onItem && it ? (e: MouseEvent) => { e.stopPropagation(); onItem(id); } : undefined;
        return (
          <span key={id} onClick={click} className={!it && loading ? 'animate-pulse' : undefined} style={{ cursor: click ? 'zoom-in' : undefined, position: 'relative', width: size, height: size, flex: 'none', borderRadius: 5, overflow: 'hidden', background: C.stripe, boxShadow: `inset 0 0 0 1px ${C.borderHi}` }}>
            {it && <VaultThumb accountId={accountId} url={itemThumb(it)} className="w-full h-full" />}
            {vid && it?.duration ? (
              <span style={{ position: 'absolute', bottom: 2, left: '50%', transform: 'translateX(-50%)', padding: '0 3px', borderRadius: 3, background: 'color-mix(in srgb, var(--om-page) 80%, transparent)', font: font(600, 8.5), color: C.text, whiteSpace: 'nowrap' }}>{fmtDuration(it.duration)}</span>
            ) : null}
          </span>
        );
      })}
      {ids.length > max && (
        <span onClick={onItem && byId.has(ids[max]!) ? (e) => { e.stopPropagation(); onItem(ids[max]!); } : undefined} style={{ cursor: onItem && byId.has(ids[max]!) ? 'zoom-in' : undefined, width: size, height: size, flex: 'none', borderRadius: 5, background: C.hover, border: `1px solid ${C.borderHi}`, boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center', font: font(600, 10.5), color: C.purplePale }}>+{ids.length - max}</span>
      )}
    </div>
  );
}
